import {App, Plugin} from 'vue'

export function formatNumber(num: number | string, scale = 2): number | string {
    if (Number.isNaN(num)) {
        return '-'
    }

    return Number.parseFloat(String(num)).toFixed(scale)
}

export default {
    install: (app: App): void => {
        app.config.globalProperties.$filters = {
            formatNumber,
        }
    }
}
